import React from 'react';
import HumanSideOfTelecom from '../components/HumanSideOfTelecom';

function HumanSideOfTelecomPage() {
  return <HumanSideOfTelecom />;
}

export default HumanSideOfTelecomPage;
